import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const whoami = (services: CommandServices) => {
  return createCommand('whoami')
    .description('Display the email of the logged in Wix user')
    .action(async (_, command) => {
      const { CliError, CliErrorCode } = await import('@wix/cli-error');
      const { getUserInfo } = await import('@wix/cli-auth');
      const { WhoamiCommand } = await import('../components/WhoamiCommand.js');
      const { renderCommand, runCommand } = await import('./render-command.js');

      const userInfo = await getUserInfo();

      if (userInfo == null) {
        await runCommand(command, services, async () => {
          throw new CliError({
            code: CliErrorCode.LoginRequired(),
            cause: null,
          });
        });
        return;
      }

      await renderCommand(
        command,
        services,
        <WhoamiCommand userInfo={userInfo} />
      );
    });
};
